import React from 'react';

import { useTranslation } from 'react-i18next';

import AdminService from '../../../../../services/AdminService';
import TableView from '../../TableView';

export default function LanguageLevels({ setItemCount }) {
  const { t } = useTranslation();

  const columns = [
    {
      name: t(
        'dashboardComponents.Console.RefDataManagement.LanguageLevels.languageLevelName'
      ),
      field: 'name',
      sortable: true,
    },
    { name: t('common.sortOrder'), field: 'sortOrder', sortable: true },
    {
      name: t('common.notes'),
      field: 'note',
      sortable: false,
    },
    {
      name: t('common.createdOn'),
      field: 'createdAt',
      sortable: true,
      type: 'date',
    },
  ];

  return (
    <TableView
      setItemCount={setItemCount}
      dataName="Language Level"
      getDataHandler={AdminService.getLanguageLevels}
      deleteDataHandler={AdminService.deleteLanguageLevel}
      createDataHandler={AdminService.createLanguageLevel}
      updateDataHandler={AdminService.updateLanguageLevel}
      viewLeftColumnFields={[{ label: 'Name', field: 'name' }]}
      viewRightColumnFields={[
        { label: t('common.sortOrder'), field: 'sortOrder' },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
        },
      ]}
      formLeftColumnFields={[
        {
          label: 'Name',
          field: 'name',
          validation: ['string', 'required'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.LanguageLevels.languageLevelNameHere'
          ),
        },
      ]}
      formRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
          validation: ['string', 'required', 'numbers'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.LanguageLevels.specifySortOrderHere'
          ),
          maxLength: 5,
        },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
          validation: ['string'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.LanguageLevels.enterAnySpecificNotesAboutTheLanguageLevel'
          ),
        },
      ]}
      columns={columns}
    />
  );
}
